<script lang="ts">
import { BundurilRepo } from '@/repo/BundurilRepo';
import { Component, Vue } from 'vue-property-decorator';
import Bubbles from './common/Bubbles.vue';
import Utils from './common/Utils';

@Component({
  components: {
    Bubbles,
  },
})
export default class App extends Vue {
  async created(): Promise<void> {
    // allow language to be set by query parameter (for tests)
    const query = Utils.getQuery();
    if (query.lang) {
      this.$i18n.locale = query.lang;
      await this.loadTranslations(query.lang);
      return;
    }

    // Load translations using browser language or fallback to English
    const languageToFetch = Utils.getBrowserLanguage();
    await this.loadTranslations(languageToFetch);
  }

  async loadTranslations(lang: string): Promise<void> {
    try {
      const translations = await BundurilRepo.getInstance().getTranslations({
        lang,
      });
      if (!translations) return;

      // Remove prefixes from translation keys before merging
      const processedTranslations = Utils.removeTranslationPrefixes(translations);

      // Merge translations into editorLang namespace
      this.$i18n.mergeLocaleMessage('editorLang', processedTranslations);
    } catch (error) {
      // Silently fail - translations will use fallback
      console.warn('Failed to load translations:', error);
    }
  }
}
</script>

<template>
  <v-app>
    <v-main>
      <Bubbles />
      <router-view />
    </v-main>
  </v-app>
</template>

<style lang="scss">
@import './styles/app.scss';
@import './styles/editor.scss';
</style>
